<template>
  <div class="content">
    <div>
      <h2 class="page-title">お問い合わせ</h2>

      <h4 class="page-sub-title pl-2 pl-md-4 mt-4">
        車両輸送に関するお問い合わせ
      </h4>
      <div class="section-wrapper">
        <section id="inquiry-syaryo">
          <div class="section-child">
            <table class="table">
              <thead>
                <tr>
                  <th>
                    お客様の
                    <br v-if="isMobile" />
                    所在地
                  </th>
                  <th class="text-center">管轄</th>
                  <th class="text-center">電話番号</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div v-if="!isMobile">
                      北海道、青森県、岩手県、宮城県
                      <br />
                      秋田県、山形県、福島県
                      <br />
                      茨城県、栃木県、群馬県、埼玉県
                      <br />
                      千葉県、東京都、神奈川県、山梨県
                    </div>
                    <div v-else class="row">
                      <p class="col-3 p-2 bold sp-fs-14 blue">
                        お客様の
                        <br v-if="isMobile" />
                        所在地
                      </p>
                      <p class="col-9">
                        北海道、青森県、岩手県、宮城県、秋田県、山形県、福島県、茨城県、栃木県、群馬県、埼玉県、千葉県、東京都、神奈川県、山梨県
                      </p>
                    </div>
                  </td>
                  <td>
                    <div v-if="!isMobile" class="text-center">東京営業所</div>
                    <div v-else class="row">
                      <p class="col-3 p-2 bold sp-fs-14 blue">管轄</p>
                      <p class="col-9 pt-2">東京営業所</p>
                    </div>
                  </td>
                  <td>
                    <div v-if="!isMobile" class="text-center">
                      050-1745-7707
                    </div>
                    <div v-else class="row">
                      <p class="col-3 p-2 bold sp-fs-14 blue">電話番号</p>
                      <p class="col-9 pt-2">
                        <a href="tel:05017457707">050-1745-7707</a>
                      </p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div v-if="!isMobile">
                      新潟県、富山県、石川県、福井県
                      <br />
                      長野県、岐阜県、愛知県、静岡県、三重県
                    </div>
                    <div v-else class="row">
                      <p class="col-3 p-2 bold sp-fs-14 blue">
                        お客様の
                        <br v-if="isMobile" />
                        所在地
                      </p>
                      <p class="col-9">
                        新潟県、富山県、石川県、福井県、長野県、岐阜県、愛知県、静岡県、三重県
                      </p>
                    </div>
                  </td>
                  <td>
                    <div v-if="!isMobile" class="text-center">名古屋営業所</div>
                    <div v-else class="row">
                      <p class="col-3 p-2 bold sp-fs-14 blue">管轄</p>
                      <p class="col-9 pt-2">名古屋営業所</p>
                    </div>
                  </td>
                  <td>
                    <div v-if="!isMobile" class="text-center">
                      050-1746-3820
                    </div>
                    <div v-else class="row">
                      <p class="col-3 p-2 bold sp-fs-14 blue">電話番号</p>
                      <p class="col-9 pt-2">
                        <a href="tel:05017463820">050-1746-3820</a>
                      </p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div v-if="!isMobile">
                      滋賀県、京都府、大阪府、兵庫県
                      <br />
                      奈良県、和歌山県、鳥取県、岡山県
                      <br />
                      島根県、徳島県、香川県、愛媛県、高知県
                    </div>
                    <div v-else class="row">
                      <p class="col-3 p-2 bold sp-fs-14 blue">
                        お客様の
                        <br v-if="isMobile" />
                        所在地
                      </p>
                      <p class="col-9">
                        滋賀県、京都府、大阪府、兵庫県、奈良県、和歌山県、鳥取県、岡山県、島根県、徳島県、香川県、愛媛県、高知県
                      </p>
                    </div>
                  </td>
                  <td>
                    <div v-if="!isMobile" class="text-center">神戸営業所</div>
                    <div v-else class="row">
                      <p class="col-3 p-2 bold sp-fs-14 blue">管轄</p>
                      <p class="col-9 pt-2">神戸営業所</p>
                    </div>
                  </td>
                  <td>
                    <div v-if="!isMobile" class="text-center">
                      050-1746-3830
                    </div>
                    <div v-else class="row">
                      <p class="col-3 p-2 bold sp-fs-14 blue">電話番号</p>
                      <p class="col-9 pt-2">
                        <a href="tel:05017463830">050-1746-3830</a>
                      </p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div v-if="!isMobile">
                      広島県、山口県、福岡県、佐賀県
                      <br />
                      長崎県、熊本県、大分県、宮崎県
                      <br />
                      鹿児島県、沖縄県
                    </div>
                    <div v-else class="row">
                      <p class="col-3 p-2 bold sp-fs-14 blue">
                        お客様の
                        <br v-if="isMobile" />
                        所在地
                      </p>
                      <p class="col-9">
                        広島県、山口県、福岡県、佐賀県、長崎県、熊本県、大分県、宮崎県、鹿児島県、沖縄県
                      </p>
                    </div>
                  </td>
                  <td>
                    <div v-if="!isMobile" class="text-center">福岡営業所</div>
                    <div v-else class="row">
                      <p class="col-3 p-2 bold sp-fs-14 blue">管轄</p>
                      <p class="col-9 pt-2">福岡営業所</p>
                    </div>
                  </td>
                  <td>
                    <div v-if="!isMobile" class="text-center">
                      050-1746-3810
                    </div>
                    <div v-else class="row">
                      <p class="col-3 p-2 bold sp-fs-14 blue">電話番号</p>
                      <p class="col-9 pt-2">
                        <a href="tel:05017463810">050-1746-3810</a>
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>

      <h4 class="page-sub-title pl-2 pl-md-4 mt-4">
        名変輸送に関するお問い合わせ
      </h4>
      <div class="section-wrapper">
        <section id="inquiry-meihen">
          <div class="section-child">
            <table class="table">
              <tbody>
                <tr v-if="isMobile">
                  <td class="w-50 text-center bold blue">登録部</td>
                  <td class="text-center align-middle">
                    <a href="tel:05017457650">050-1745-7650</a>
                  </td>
                </tr>
                <tr v-else>
                  <td class="w-50 text-center">登録部</td>
                  <td class="text-center align-middle bold blue">
                    050-1745-7650
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>

      <h4 class="page-sub-title pl-2 pl-md-4 mt-4">
        リース会社またはリース車両をご利用のお客様
      </h4>
      <div class="section-wrapper">
        <section id="inquiry-lease">
          <div class="section-child">
            <table class="table">
              <tbody>
                <tr v-if="isMobile">
                  <td class="w-50 text-center bold blue">法人輸送部</td>
                  <td class="text-center align-middle">
                    <a href="tel:05017457720">050-1745-7720</a>
                  </td>
                </tr>
                <tr v-else>
                  <td class="w-50 text-center">法人輸送部</td>
                  <td class="text-center align-middle bold blue">
                    050-1745-7720
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>

      <h4 class="page-sub-title pl-2 pl-md-4 mt-4">メールでのお問い合わせ</h4>
      <div class="section-wrapper">
        <section id="inquiry-mail">
          <validation-observer ref="observer" method="post">
            <div class="section-child m-2">
              <validation-provider
                v-slot="{ errors }"
                rules="max:300|char"
                name="inquiry_text"
              >
                <b-form-textarea
                  ref="inquiry_text"
                  v-model="form.inquiry_text"
                  :state="errors.length ? false : null"
                  trim
                  rows="6"
                  maxlength="300"
                  placeholder="お問い合わせ内容…"
                  @blur="form.inquiry_text = replaceChar(form.inquiry_text)"
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
          </validation-observer>

          <div class="text-center mt-1 mr-3 mr-md-0">
            <md-button
              type="button"
              class="btn-lg btn-success base-btn col-lg-4 md-raised"
              @click="confirm"
              :disabled="!form.inquiry_text"
            >
              内容を確認する
            </md-button>

            <!-- 問い合わせ内容確認 -->
            <md-dialog
              :md-active.sync="showMailConfirmDialog"
              class="new w-800"
              :md-fullscreen="false"
              @md-opened="scroll('locked')"
              @md-closed="scroll('clear')"
            >
              <md-dialog-title>お問い合わせ内容</md-dialog-title>
              <div
                class="p-4 mx-4 bg-gray"
                v-html="sanitize(form.inquiry_text)"
              />
              <div class="text-center mr-3 mr-md-0 mt-3">
                <md-button
                  type="button"
                  class="btn-lg btn-success base-btn col-md-2"
                  @click="sendMail()"
                >
                  送信
                </md-button>
              </div>
              <md-dialog-actions>
                <md-button
                  class="md-primary"
                  @click="showMailConfirmDialog = false"
                >
                  閉じる
                </md-button>
              </md-dialog-actions>
            </md-dialog>

            <md-dialog-alert
              class="new"
              :md-fullscreen="false"
              @md-opened="scroll('locked')"
              @md-closed="scroll('clear')"
              :md-active.sync="isSent"
              md-content="<strong>お問い合わせを受け付けました。<br>折り返し弊社担当より連絡いたしますので、少々お待ちください。</strong>"
            />
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Mixin from '../mixin/Mixin'
import Store from '@/store/index.js'
export default {
  name: 'Detail',
  components: {},
  mixins: [Mixin],
  data: () => ({
    form: {
      inquiry_text: '',
      JYUCYU_SHIKI_CD: '',
      ID: '',
    },
    showMailConfirmDialog: false,
    isSent: false,
  }),
  methods: {
    sendMail() {
      this.showMailConfirmDialog = false
      this.spinerOn()
      return this.$store
        .dispatch('inquiry/sendMail', this.form)
        .then((res) => {
          this.isSent = true
          this.form.inquiry_text = ''
          this.scroll('clear')
          this.spinerOff()
        })
        .catch((err) => {
          this.scroll('clear')
          this.spinerOff()
          throw new Error(err.message)
        })
    },

    async confirm() {
      this.spinerOff()
      const validResult = await this.$refs.observer.validate()
      if (!validResult) return this._alert('入力項目にエラーがあります。')
      this.showMailConfirmDialog = true
    },
  },
  created() {
    this.form.JYUCYU_SHIKI_CD = Store.state.user.data.JYUCYU_SHIKI_CD
    this.form.ID = Store.state.user.data.ID
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
  td
    background: #fff
section#inquiry-mail
  margin: 0 auto
  width: 50%
  @include sp
    width: auto
#mail-modal
  width: 50%
  @include sp
    width: auto
</style>



// WEBPACK FOOTER //
// src/components/inquiry/Index.vue